import React from 'react';
import './About.css';

import profileImage from '../../assets/images/profile-crop-mod.jpeg';

const About = () => {
    return (
        <main className="About TextShadow">
            <div className="About__Container">
                <div className="About__GridContainer">
                    <div className="About__ProfileContainer">
                        <div className="About__Profile">
                            <img
                                className="About__ProfileImage Shadow--Lowered"
                                src={profileImage}
                            />
                            <div>
                                <div className="About__ProfileName">
                                    Daniela Pessotto-Robba
                                </div>
                                <div className="About__ProfileResidence">
                                    Australind, WA
                                </div>                                  
                                <div className="About__ProfileQuoteIntro">
                                    My favourite quote is:
                                </div>    
                                <div className="About__ProfileQuote">
                                    ‘’Every artist dips his brush in his own soul and paints his own nature into his pictures’’
                                </div>     
                                <div className="About__ProfileQuoteAuthor">
                                    (Henry Ward Beeches)
                                </div>               
                            </div>                  
                        </div>                       
                    </div>
                    <div className="About__ParagraphContainer">
                        <div>
                            <h3>About the Artist</h3>
                            <p>
                                Daniela is a West Australian wildlife artist.
                                Her love and talent for drawing and painting is
                                innate and she had always been known to have a
                                coloured pencil or brush in her hand. Daniela's
                                talent really evolved during her teenage years
                                when countless hours were spent trying to
                                capture the realistic look of the many native
                                birds, animals and wildflowers around her home
                                on the farm.
                            </p>
                            <br />
                            <p>
                                Wanting to recreate to perfection what she saw
                                in front of her the way she saw it caused her to
                                be her biggest critic. She was so mesmerized by
                                nature's beauty, and it still never ceases to
                                truly amaze her.
                            </p>
                            <br />
                            <p>
                                Daniela is accomplished in using various mediums
                                such as oils, watercolours and acrylics, however
                                pencils are her preferred medium when creating
                                wildlife drawings.
                            </p>
                            <br />
                            <p>
                                Daniela has a Diploma in Commercial Art which
                                she successfully completed via correspondence
                                with the Art Training Institute of Victoria in
                                her teenage years.
                            </p>
                        </div>
                        <div>
                            <h3>Passion</h3>
                            <p>
                                To share her artwork of our unique wildlife as a
                                way to help others become more aware of how
                                precious our wildlife and environment are; to
                                inspire them to take steps in preserving and
                                caring for their natural surroundings.
                            </p>
                        </div>
                        <div>
                            <h3>History</h3>
                            <p>
                                Daniela was born in 1962 and grew up and lived
                                in Manjimup until she moved overseas to Italy in
                                1990 with her newly married husband. There she
                                lived for ten years where she gave birth to her
                                two sons. In 2000 she moved back to WA Australia
                                with the family and settled in Australind.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default About;
